/* eslint-disable max-len */
import {useEffect, useRef, useState} from 'react';
import sdk from '@/sdk';
import mentionCache from '@/utils/document/mentionCache';
import {EDITOR_MODE} from '@/Constant';
import * as store from '@/store';
import {ArrowDownSvg, ArrowUpSvg} from '@/icons';
import Icon, {IconSize} from '@/components/Icon';
import {Popper, PopperTrigger} from '@baidu/luffy';
import Avatar, {AvatarSize} from '@/components/Avatar';

import styles from './index.module.scss';
import {MentionType} from '@/constants/document/mention';
import {unionBy, differenceWith, filter, includes, compact} from 'lodash-es';
import eventBus, {COMMENT_INFO_CHANGE, COMMENT_LIST_CHANGE} from '@/eventBus';
import {Iitems} from '@/components/shareCollaborate/search/searchContent';
import {getMorphoService, serviceNames} from '@/rte/editor';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';
import {isMac} from '@/utils/commonUtils';

interface ItemProps {
    type: 'emtion' | 'service';
    itemInfo: any;
    createGroup?: boolean;
}

const ListItem = (props: ItemProps) => {
    const {type, itemInfo, createGroup = false} = props;
    let mtag = '群聊';
    if (!createGroup) {
        if (itemInfo.mentionType === MentionType.contact) {
            mtag = '单聊';
        }
    }

    return <div className={styles.listItemBox}>
        <Avatar
            size={AvatarSize.XS}
            className="avatar"
            userGuid={itemInfo.mentionType === MentionType.contact ? itemInfo.userId : ''}
            gid={itemInfo.gid}
            defaultText={itemInfo.mentionName || ''}
        />

        <PopperTrigger type="hover">
            <div className={styles.name} style={{maxWidth: type === 'emtion' ? (isMac() ? 100 : 93) : 79}}>
                {itemInfo.mentionName}
            </div>
            <Popper className={styles.popperWrap2} placement={'bottom-start'}>
                <div className={styles.info}>
                    {
                        itemInfo.mentionType === MentionType.contact ? (
                            <div className={styles.infoWrap}>
                                <div>{itemInfo.mentionName} {itemInfo.mentionDescription}</div>
                                <div>{itemInfo.mentionSubtitle}</div>
                            </div>
                        ) : (
                            <div className={styles.infoWrap}>{itemInfo.mentionName}</div>
                        )
                    }
                </div>
            </Popper>
        </PopperTrigger>

        <div className={styles.tag}>
            {type === 'emtion' ? mtag : itemInfo.serviceType === 'creator' ? '文档创建者' : '评论参与者'}
        </div>
    </div>;
};

export const useCommentNoticeInfo = (docGuid: string, repositoryGuid: string, isKuShare: boolean): [any] => {
    const CommentNoticeInfo = (props: {slotId: string, commentId: string, isEdit: boolean, createGroup: boolean}) => {
        const {slotId: slotIdProp, commentId: commentIdProp, isEdit, createGroup} = props;
        const [menList, setMenList] = useState<any[]>([]);
        const [serviceList, setServiceList] = useState<any[]>([]);
        const [isHover, setIsHover] = useState<boolean>(false);
        const subLength = useRef(0);
        const menlistRef = useRef<any[]>([]);
        const serlistRef = useRef<any[]>([]);
        const subSurRef = useRef<any[]>([]);
        const chatTitleRef = useRef<string>('通过「单聊/群聊」通知');
        const listLength = menList.length + serviceList.length + subLength.current;
        let hoverInfo = '';
        const schatList = menList.filter(item => item.mentionType === MentionType.group);
        const alength = menList.length - schatList.length + subLength.current + serviceList.length;
        const blength = schatList.length;

        if (createGroup) {
            if (menList.length > 0) {
                const isChatSingle = menList.every(item => item.mentionType === MentionType.contact);
                const createGroupALength = subLength.current + serviceList.length;
                if (isChatSingle) {
                    let str = '';
                    if (createGroupALength > 0) {
                        str = createGroupALength + '人';
                    }
                    str += str ? ',' : '';
                    hoverInfo = str + '1群聊';
                } else {
                    let str = '';
                    if (createGroupALength > 0) {
                        str = createGroupALength + '人';
                    }
                    if (blength > 0) {
                        str += str ? ',' : '';
                        str += (blength + 1) + '群聊';
                    }
                    hoverInfo = str;
                }
            } else {
                let str = '';
                if (alength > 0) {
                    str = alength + '人';
                }
                if (blength > 0) {
                    str += str ? ',' : '';
                    str += blength + '群聊';
                }
                hoverInfo = str;
            }
        } else {
            let str = '';
            if (alength > 0) {
                str = alength + '人';
            }
            if (blength > 0) {
                str += str ? ',' : '';
                str += blength + '群聊';
            }
            hoverInfo = str;
        }


        // 缓存数据处理多次渲染和请求
        const topList = useRef(0); // 提及的列表长度
        const resignList = useRef(0); // 请求离职接口的参数长度

        const editMode = store.getDocumentMode() === EDITOR_MODE.edit;

        // 判断是否离职
        async function getUserResignList(userGuids: string[], mentionList: Iitems[]) {
            try {
                const ksServer = await sdk.getKsServer();
                const result = await ksServer.getUserResign(userGuids);
                if (result.length > 0) {
                    // result是离职人员
                    const list = filter(mentionList, (item: Iitems) => {
                        if (item.userGuid) {
                            return !includes(result, item.userGuid);
                        } else {
                            return true;
                        }
                    });
                    menlistRef.current = list;
                    setMenList(list);
                } else {
                    menlistRef.current = mentionList;
                    setMenList(mentionList);
                }
            } catch (error) {
                console.log('error', error);
            }
        }

        async function getCommentFocusList(participantIds: Iitems[]) {
            try {
                const ksServer = await sdk.getKsServer();
                const result = await ksServer.getCommentListFocus(
                    repositoryGuid,
                    docGuid,
                    participantIds
                );
                const creator = result.creator; // 创建者
                let participants = result.participants.filter((item: Iitems) => item.userGuid !== sdk.as.user!.userGuid); // 参与者
                let subscribers = result.subscribers.filter((item: Iitems) => item.userGuid !== sdk.as.user!.userGuid); // 关注者
                subSurRef.current = subscribers;
                const list2: Iitems[] = [];

                if (creator && creator.userGuid !== sdk.as.user!.userGuid) {
                    // 优先展示评论参与者
                    const tag = participants.filter((item: Iitems) => item.userGuid === creator.userGuid).length === 1;
                    // 创建者没关注文档需要过滤
                    const tag2 = subscribers.filter((item: Iitems) => item.userGuid === creator.userGuid).length === 1;
                    if (!tag && tag2) {
                        list2.push({
                            ...creator,
                            serviceType: 'creator',
                        });
                    }
                }
                participants = [...participants].map((item: Iitems) => {
                    return {
                        ...item,
                        serviceType: 'participant',
                    };
                });

                list2.push(...participants);

                // 关注者个数
                subscribers = [...subscribers].map((item: Iitems) => {
                    return {
                        ...item,
                    };
                });

                subLength.current = differenceWith(subscribers, [...menlistRef.current, ...list2], (a: Iitems, b: Iitems) => a.userGuid === b.userGuid).length;

                // 提及@的优先
                const menUserGuids = menlistRef.current.map((item: Iitems) => item.userGuid);

                const filteredServiceList = list2.filter(
                    (item: Iitems) => !menUserGuids.includes(item.userGuid)
                );
                // 某个人是提及和服务号 优先展示提及人员
                const endList = [...filteredServiceList].map((item: Iitems) => {
                    return {
                        ...item,
                        mentionName: item.nickname,
                        mentionDescription: item.department,
                        mentionSubtitle: item.email,
                        userId: item.userGuid,
                        mentionType: MentionType.contact,
                    };
                });
                const slist = [...unionBy(endList, 'userGuid')];
                serlistRef.current = slist;
                setServiceList(slist);
            } catch (error) {
                console.log('error', error);
            }
        }

        useEffect(() => {
            function handleCommentListChange(data: any) {
                const commentId = data.commentId;
                if (commentIdProp && commentIdProp !== commentId) {
                    // 处理服务号
                    if (data.members && data.members.length > 0) {
                        // getCommentFocusList(data.members.map((item: any) => item.userId));
                    }
                }
            }
            eventBus.on(COMMENT_LIST_CHANGE, handleCommentListChange);
            return () => {
                eventBus.off(COMMENT_LIST_CHANGE, handleCommentListChange);
            };
        }, []);

        useEffect(() => {
            function handleCommentChange({mentionInfos, slotId}: any) {
                if (slotId !== slotIdProp) {
                    return;
                }
                const mentionList = mentionInfos[0] && mentionInfos[0].mentionList;
                const noticeMentions: any[] = [];
                // 处理提及信息
                if (mentionList && mentionList.length > 0) {
                    setTimeout(() => {
                        if (topList.current > 0 && topList.current === mentionList.length) {
                            return;
                        }
                        topList.current = mentionList.length;

                        mentionList.forEach((info: any) => {
                            if (info?.isVirtualUser) {
                                return;
                            }
                            const data = mentionCache.get(info.uuid);
                            if (
                                data &&
                                !data.options.fromPaste &&
                                data.info.id !== sdk.as.user!.userGuid
                            ) {
                                // @人
                                if (data.info.type === MentionType.contact) {
                                    if (data.options.checked) {
                                        noticeMentions.push({
                                            ...info,
                                            userId: data.info.id,
                                            userGuid: data.info.id,
                                        });
                                    }
                                }
                                // @群组
                                if (data.info.type === MentionType.group) {
                                    noticeMentions.push({
                                        ...info,
                                        gid: data.info.id,
                                    });
                                }
                            }
                        });

                        let noticeMentionList: any[] = noticeMentions.filter((item: any) => item.mentionType === MentionType.contact);
                        let noticeMentionGroupList: any[] = noticeMentions.filter((item: any) => item.mentionType === MentionType.group);
                        noticeMentionList = [...unionBy(noticeMentionList, 'userId')];
                        noticeMentionGroupList = [...unionBy(noticeMentionGroupList, 'gid')];
                        const mlist = [...noticeMentionList, ...noticeMentionGroupList];
                        if (mlist.length > 0) {
                            const userGuids = compact(mlist.map((item: any) => item.userGuid));
                            if (resignList.current > 0 && resignList.current === userGuids.length) {
                                menlistRef.current = mlist;
                                setMenList(mlist);
                                return;
                            }
                            resignList.current = userGuids.length;
                            if (userGuids.length > 0) {
                                getUserResignList(userGuids, mlist);
                            } else {
                                menlistRef.current = mlist;
                                setMenList(mlist);
                            }
                        } else {
                            menlistRef.current = [];
                            setMenList([]);
                        }

                    }, 500);
                } else {
                    menlistRef.current = [];
                    setMenList([]);
                }
            }

            eventBus.on(COMMENT_INFO_CHANGE, handleCommentChange);
            return () => {
                eventBus.off(COMMENT_INFO_CHANGE, handleCommentChange);
            };
        }, []);


        useEffect(() => {
            if (createGroup) {
                chatTitleRef.current = '通过「群聊」通知';
            } else {
                if (menList && menList.length > 0) {
                    const isChatSingle = menList.every(item => item.mentionType === MentionType.contact);
                    const isChatGroup = menList.every(item => item.mentionType === MentionType.group);
                    if (isChatSingle) {
                        chatTitleRef.current = '通过「单聊」通知';
                    } else if (isChatGroup) {
                        chatTitleRef.current = '通过「群聊」通知';
                    } else {
                        chatTitleRef.current = '通过「单聊/群聊」通知';
                    }
                } else {
                    chatTitleRef.current = '通过「单聊/群聊」通知';
                }
            }

            // 提及@的优先
            const menUserGuids = menList.map((item: Iitems) => item.userGuid);
            const filteredServiceList = serlistRef.current.filter(
                (item: Iitems) => !menUserGuids.includes(item.userGuid)
            );
            subLength.current = differenceWith(subSurRef.current, [...menList, ...filteredServiceList], (a: Iitems, b: Iitems) => a.userGuid === b.userGuid).length;

            // 某个人是提及和服务号 优先展示提及人员
            setServiceList(filteredServiceList);
        }, [menList, createGroup]);

        // 默认获取服务号列表
        useEffect(() => {
            const editorStateService = getMorphoService(serviceNames.IEditorStateService);
            if (commentIdProp) {
                if (!editorStateService) {
                    return;
                }
                const {MorphoAPI} = editorStateService?.editor || {};
                const list = MorphoAPI.getCommentMembers(commentIdProp);
                if (list && list.length > 0) {
                    getCommentFocusList(list.map((item: any) => item.userId));
                }
            } else {
                getCommentFocusList([]);
            }
        }, []);

        return !isEdit && listLength > 0 ? (
            listLength !== subLength.current ? <PopperTrigger
                type="hover"
                onChange={() => {
                    setIsHover(!isHover);
                }}
            >
                <div className={styles.box}>
                    {editMode ? '文档发布后将通知' : `${!isKuShare ? '评论后将' : ''}通知`}
                    <span className={styles.sizeColor}>{hoverInfo}</span>
                    {
                        !isHover ? <ArrowDownSvg style={{margin: '0px 0px 5px 3px', width: 8, height: 8, color: 'rgba(57, 64, 77, 1)'}} /> : <ArrowUpSvg style={{margin: '0px 0px 5px 3px', width: 8, height: 8, color: 'rgba(57, 64, 77, 1)'}} />
                    }
                </div>
                <Popper className={styles.popperWrap} placement={'bottom-start'}>
                    <div className={styles.popover}>
                        {
                            menList.length > 0 && <div>
                                <div className={styles.title}>{chatTitleRef.current}</div>
                                {
                                    menList.map((itemInfo: any) => {
                                        return <ListItem itemInfo={itemInfo} type="emtion" key={itemInfo.uuid} createGroup={createGroup} />;
                                    })
                                }

                                {
                                    listLength !== menList.length && <div className={styles.line}></div>
                                }
                            </div>
                        }
                        {
                            serviceList.length > 0 && <div>
                                <div className={styles.titleNotice}>通过「如流服务号」通知</div>
                                {
                                    serviceList.map((itemInfo: any) => {
                                        return <ListItem itemInfo={itemInfo} type="service" key={itemInfo.uuid} />;
                                    })
                                }
                            </div>
                        }
                        {
                            subLength.current > 0 && <div className={styles.other}>
                                及其他 <span className={styles.otherCounter}>{subLength.current}</span> 位该文档的评论关注者
                            </div>
                        }
                    </div>
                </Popper>
            </PopperTrigger> : <div className={styles.box}>
                {editMode ? '文档发布后将通知' : `${!isKuShare ? '评论后将' : ''}通知`}
                <span className={styles.gzColor}>{listLength + '人(评论关注者)'}</span>
            </div>
        ) : null;
    };

    return [CommentNoticeInfo];
};
